const r = [
  "number-one",
  "number-two",
  "number-three",
  "number-four",
  "number-five",
  "number-six",
  "number-seven",
  "number-eight",
  "number-nine",
  "minus",
  "twitter",
  "facebook",
  "translation",
  "ambassador-sidebar",
  "chat-lock",
  "private-room",
  "circle-close",
  "membership",
  "search",
  "pin",
  "gp",
  "types_of_exchanges",
  "guarantees",
  "up-arrow",
  "down-arrow",
  "selection-tick-selected",
  "ic-location",
  "header-profile-profile",
  "creme_email",
  "home",
  "credit-card",
  "header-profile-home",
  "keys",
  "plus",
  "heart",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "button-power",
  "header-help",
  "header-message-read",
  "header-message-new",
  "right_arrow",
  "instagram",
  "information-circle",
  "tiktok",
  "linkedin",
  "youtube",
  "remove",
  "verification-check",
  "notification",
  "user",
  "checkbox-fill",
  "error-warning-fill",
  "error",
  "warning",
  "wifi",
  "tv",
  "bathtub",
  "dishwasher",
  "washing-machine",
  "dryer",
  "heating-system",
  "electric-car-plug",
  "disabled-access",
  "microwave-oven",
  "freezer",
  "oven",
  "fridge",
  "computer",
  "internet",
  "home-cinema",
  "satellite-cable",
  "phone",
  "video-game-console",
  "smart-tv",
  "swimming-pool",
  "garden",
  "balcony-terrace",
  "elevator",
  "ac",
  "fireplace",
  "parking-space",
  "car",
  "bicycle",
  "gym",
  "bbq",
  "jacuzzi",
  "motorcycle",
  "tennis-court",
  "ping-pong-table",
  "sauna",
  "pool-table",
  "motor-scooter",
  "motorboat",
  "sailboat",
  "electric-car",
  "baby-sitter",
  "cook",
  "guide",
  "kids-toys",
  "kids-playground",
  "baby-gear",
  "secured-swimming-pool",
  "renewable-energy-provider",
  "low-consumption-machines",
  "selective-waste-sorting",
  "vegetable-garden",
  "public-transit-access",
  "solar-panels",
  "high-speed-connection",
  "dedicated-work-space",
  "children-welcome",
  "pets-welcome",
  "smokers-welcome",
  "dog-to-feed",
  "cat-to-feed",
  "plants-to-water",
  "rabbit",
  "countryside",
  "mountains",
  "seaside",
  "lakes",
  "cities",
  "villages",
  "isolated",
  "island",
  "available-exchange-type",
  "reciprocal-exchange-type",
  "guestpoint-exchange-type",
  "search-location-pin",
  "pencil",
  "flat",
  "house",
  "river",
  "circle-right-arrow"
], o = {
  translation: 4,
  "selection-tick-selected": 2
}, a = r.map((e) => ({
  name: e,
  class: `icon-${e}`,
  transform: o[e]
}));
export {
  r as ICON_NAMES,
  a as IconList
};
